<template>
  <div class="protect page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="createQrCode()"
          >生成护学岗二维码</el-button
        >
      </div>
     
      <div class="search_box">
        <el-input
          v-if="regionCode == 411481"
          style="width:200px;margin-left:5px"
          placeholder="请输入老师名称"
          v-model.trim="reqData.userName"
          size="mini"
          clearable
        >
        </el-input>
        <el-select
          size="mini"
          v-model="reqData[regionCode == 411481?'state':'status']"
          placeholder="请选择任务状态"
          style="width:200px;margin-left:5px"
        >
          <el-option
            v-for="item in stateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div v-show="showNotice" class="new_version_notice">
      <div class="info">
          <img src="@/assets/notice.png" alt="">
          <div> 护学岗小程序已上线 <p @click="showWxminiCode">点击扫码体验</p> </div>
          <div @click="closeNotice" style="cursor: pointer;display: flex;justify-content:flex-end ">
                      <el-icon   class="el-icon-close"></el-icon>

          </div>
      </div>
      <span  class="desc">护学岗微信小程序已上线，可扫码前去体验与H5护学岗功能相同，操作方式相同，更改登录方式为一键登录，优化了UI样式以及操作，护学功能更加简单，界面更加整洁，同时增加了全景监控以及语音广播实时喊话功能。</span>
    </div>
    <div class="page_table_box"  :style="showNotice?'height:calc( 100% - 160px)':'100%'">
      <div class="school_table_box">
        <el-table
          :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
          :data="tableData"
          :height="showNotice?'calc( 100% - 84px)':'100%'"
          class="table_box"
          v-if="regionCode == 411481"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="schoolName"
            label="学校名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            prop="isPs"
            label="上岗人类型"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              {{ $Common.getDataName(isPsList, scope.row.isPs) }}
            </template>
          </el-table-column> -->
          <el-table-column
            prop="userName"
            label="上岗人名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="上岗时间"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              {{ $Common.dateFormatDateTwo(scope.row.startTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="onPlace"
            label="上岗地点"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="postPhoto"
            label="上岗图片"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <el-image
                style="width: 60px; height: 60px"
                :src="fileUrl + scope.row.postPhoto"
                :preview-src-list="[fileUrl + scope.row.postPhoto]"
              >
                >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="下岗时间"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <span v-if="scope.row.endTime != 0">
                {{ $Common.dateFormatDateTwo(scope.row.endTime) }}
              </span>
              <span v-else>护学中</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="downPlace"
            label="下岗地点"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <span v-if="scope.row.downPlace">
                {{ scope.row.downPlace }}
              </span>
              <span v-else>护学中</span>
            </template>
          </el-table-column>
          <el-table-column
            label="护岗状态"
            width="150"
            align="center"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <el-tag type="success" size="small" v-if="scope.row.state == 1"
                >上岗中</el-tag
              >
              <el-tag type="info" size="small" v-else>已下岗</el-tag>
            </template>
          </el-table-column>
        </el-table>


        <el-table
          :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
          :data="tableData"
          height="100%"
          class="table_box"
          v-else
        >
              <el-table-column label="序号" width="70" align="center">
                <template slot-scope="scope">
                  {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="schoolName" label="学校名称" align="center" width="160"></el-table-column>
              <el-table-column prop="userName" label="姓名" align="center" width="100"></el-table-column>
              <el-table-column prop="pt" label="身份" align="center" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.pt==1?'警察':'老师' }}</span>
                </template>
              </el-table-column>
              
              
              <el-table-column prop="picture" label="上岗图片" align="center">
                <template slot-scope="scope">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="fileUrl + scope.row.picture"
                    :preview-src-list="[fileUrl + scope.row.picture]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="endTime" label="下岗时间" align="center" width="160">
                <template v-slot="scope">
                    <span  v-if="scope.row.status==1">
                      护学中
                    </span>
                    <span v-else>
                      {{ $Common.dateFormatDateTwo(scope.row.endTime) }}
                    </span>
                </template>
              </el-table-column>
              <el-table-column prop="downLocation" label="下岗地点" align="center" width="120" show-overflow-tooltip>
                <template v-slot="scope">
                    <span  v-if="scope.row.status==1">
                      护学中
                    </span>
                    <span v-else>
                      {{ scope.row.downLocation }}
                    </span>
                </template>
              </el-table-column> -->
              
              <el-table-column prop="startTime" label="上下岗时间" align="center" width="260">
                <template v-slot="scope">
                    上岗：<span>{{ $Common.dateFormatDateTwo(scope.row.startTime) }}</span>
                    <br />
                    下岗：<span  v-if="scope.row.status==1">护学中</span>
                    <span v-else>{{ $Common.dateFormatDateTwo(scope.row.endTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="upLocation" label="上下岗地点" align="center" width="360">
                <template v-slot="scope">
                  <span>{{ scope.row.upLocation }}</span>
                  <br>
                  <span  v-if="scope.row.status==1">
                    护学中
                  </span>
                  <span v-else>
                    {{ scope.row.downLocation }}
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="content" width="140" label="护岗内容" align="center" show-overflow-tooltip></el-table-column> -->
              <el-table-column prop="content" label="护学人数" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="remarks" width="140" label="突发事件记录" align="center" show-overflow-tooltip>
                <template v-slot="scope">
                    <span  v-if="scope.row.status==1">
                      护学中
                    </span>
                    <span v-else>
                      {{ scope.row.remarks }}
                    </span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="护岗状态" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status==1 ? 'success' : 'info'">{{ scope.row.status==1 ? '上岗中' : '已下岗' }}</el-tag>
                </template>
              </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page="reqData.pageNum"
          :page-size="reqData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 下载二维码 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px"
    >
      <div id="qrCanvas" style="background:#fff;padding:20px;">
        <div class="dialog-content">
          <vue-qr ref="qr" :text="qrCode" :size="350" :logoSrc="regionCode == 411481?null:qrLogo"></vue-qr>
          <!-- <el-image src="../../../assets/qrLogo.png"></el-image>
          <img src="../../../assets/qrLogo.png" alt=""> -->
        </div>
        <div style="text-align:center;font-size:18px;font-family: ;">护学岗二维码</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadQR()" size="mini">下载二维码</el-button>
      </div>
    </el-dialog>
        <el-dialog
      :visible.sync="wxCodeVisible"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="440px"
    >
      <div id="qrCanvas" style="padding:20px;">
        <h3 style="text-align:center;color: #000;">护学岗小程序</h3>
        <div class="dialog-content">
          <!-- <el-image src="../../../assets/qrLogo.png"></el-image>
          <img src="../../../assets/qrLogo.png" alt=""> -->
          <img style="width: 300px;" src="@/assets/wxcode.jpg" alt="">
        </div>
        <div style="text-align:center;font-size:13px;color:#1a1a1a;margin-top:20px">请使用微信扫描二维码</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wxCodeVisible=false" size="medium"  style="background:#0256FF" >关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import html2canvas from "html2canvas";

export default {
  name: "protectList",
  components: {
    vueQr
  },
  props: {},
  data() {
    return {
      fileUrl: this.$store.state.config.fileUrl,
      reqData: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        userName: "",
        state: 0,
        status: 0,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      qrCode: "",
      regionCode:'',
      qrLogo:require('../../../assets/qrLogo.png'),
      wxCodeVisible:false,
      showNotice:true
    };
  },
  created() {
    this.regionCode = this.userInfo.loginId.slice(0, 6);
    this.getList();
  },
  mounted() {},
  watch: {},
  computed: {
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    },
    stateList() {
      return [
        { id: 0, name: "全部" },
        { id: 1, name: "已上岗" },
        { id: 2, name: "已下岗" }
      ];
    }
  },
  methods: {
    closeNotice(){
  
      this.showNotice=false
    },
    showWxminiCode(){
      this.wxCodeVisible=true
    },
    searchData() {
      this.reqData.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      this.getList();
    },
    async getList() {
      let req = Object.assign({}, this.reqData);
      let res
      if(this.regionCode == 411481){
        //永城市学校
        delete req.status
        res = await this.$Http.getProtectList(req);
      }else{
        // 其他学校
        delete req.userName
        delete req.state
        res = await this.$Http.gethxgschoolRecordsList(req);
      }
      
      if (res.code == 200) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    createQrCode() {
      let code = this.$store.state.schoolId;
      let str = this.regionCode == 411481?'bps':'hxg'
      this.qrCode = `https://school.zzsasoft.com/${str}/?code=${code}`;
      this.dialogVisible = true;
    },
    downloadQR() {
      this.canvasToImg();
      
    },

    canvasToImg(){
      console.log('canvas')
      let that = this
      // 获取相应的canvasdom元素（id、class、tag）
      const dom = document.getElementById('qrCanvas')
      html2canvas(dom , {
        // 参数说明
        backgroundColor: null,
        userCORS: true
      }).then( canvas => {
        // 设置生成的图片格式
        let dataURL = canvas.toDataURL('image/png')
        console.log(dataURL)

        let a = document.createElement("a");
        let schoolName = this.$store.state.schoolInfo.schoolName;
        // 下载图名字
        a.download = schoolName;
        //url
        a.href = dataURL;
        // a.href = this.$refs.qr.$el.src;
        //合成函数，执行下载
        a.dispatchEvent(new MouseEvent("click"));
      }).catch(err => {
        console.log(err)
      })
    }
  }
};
</script>
<style scoped lang="scss">
.page_table_box{
  // height:calc(100% -  160px) ;
}
.dialog-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0;
}
.dialog-footer {
  text-align: center;
}
/deep/.el-dialog{
  border-radius: 12px;
}
/deep/.el-dialog__body{
    border-radius: 12px;

}
</style>
<style lang="scss">
.protect{
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding:0;
  }
}
.new_version_notice{
  background: #D9E1FF;
  height: 80px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px;
  margin-top: 10px;
  border-radius: 6px;
  .info{
    width: 100%;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.9);
    font-size: 14px;
    img{
      width: 18px;
      margin-right: 10px;
      height: auto;
    }
    div{
      flex: 1;
      display: flex;
      align-items: center;
      p{
        margin: 0;
        margin-left: 10px;
        color: #0052D9;
        cursor: pointer;
      }
    }
    }
    .desc{
      color: rgba(0, 0, 0, 0.6);
      font-size: 14px;
      line-height: 22px;margin-top: 5px;
      margin-left: 26px;
    }
}

</style>
